import React, { useMemo, useState } from "react";
import { observer } from "mobx-react";
import { InputNumber } from "antd";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { useStore } from "../../../../../../../../store/rootStore";
import { getDirection } from "../../../../../../../../helpers";
import { MySelect } from "../../../../../../../Base/Form";
import s from "./ReplyActionDuration.module.scss";
const HOUR = 60 * 60;
const WEEK_HOURS = 24 * 7;
const PRESET_HOURS = [24, 48, 72, WEEK_HOURS];
const MAX_CUSTOM_HOURS = 24 * 30; // 30 days
const ReplyActionDuration = () => {
    const { t } = useTranslation();
    const { templateMessagesStore } = useStore();
    const { templateReplyActionDuration, setTemplateReplyActionDuration } = templateMessagesStore;
    const hours = Math.round(templateReplyActionDuration / HOUR);
    const [isCustom, setIsCustom] = useState(!PRESET_HOURS.includes(hours));
    const timeOptions = useMemo(() => [
        { value: "24", label: t("hoursNumber", { number: 24 }) },
        { value: "48", label: t("hoursNumber", { number: 48 }) },
        { value: "72", label: t("hoursNumber", { number: 72 }) },
        { value: String(WEEK_HOURS), label: t("timeOption1Week") },
        { value: "custom", label: t("custom") },
    ], [t]);
    const handleSelect = (value) => {
        if (value === "custom") {
            setIsCustom(true);
            return;
        }
        setIsCustom(false);
        setTemplateReplyActionDuration(parseInt(value, 10) * HOUR);
    };
    const handleCustomHours = (value) => {
        if (!value || value < 1) {
            return;
        }
        setTemplateReplyActionDuration(Math.round(value) * HOUR);
    };
    const durationSelect = (React.createElement(MySelect, { value: isCustom ? "custom" : String(hours), onChange: handleSelect, options: timeOptions, className: isCustom ? s.customSelect : s.select }));
    return (React.createElement("div", { className: classnames(s.durationBlock, { [s.rtl]: getDirection() === "rtl" }) },
        React.createElement("label", { className: s.label }, t("replyActionValidityLabel")),
        isCustom ? (React.createElement("div", { className: s.customInputGroup },
            durationSelect,
            React.createElement(InputNumber, { size: "large", value: hours, onChange: handleCustomHours, className: s.customNumber, min: 1, max: MAX_CUSTOM_HOURS }),
            React.createElement("span", { className: s.unit }, t("hours")))) : (durationSelect)));
};
export default observer(ReplyActionDuration);
